module.exports = __webpack_public_path__ + "img/canary-ride-DMt6bB9Q78c-unsplash1.10b18518.png";